import React, { useEffect, useState } from "react";
import "./CreateNewQB.css";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios";
import CreateQuestion from "../../../Components/QuestionEditCreate/CreateQuestion";
import ComponentType from "../../../Enum/ComponentTypeEnum";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
export default function CreateNewQB({ componentType }) {
  const navigate = useNavigate();
  const CTRole_Information = JSON.parse(
    localStorage.getItem("role_as_class_teacher"),
  );
  const CoRole_Information = JSON.parse(
    localStorage.getItem("role_as_co_ordinator"),
  );
  const general_role = JSON.parse(localStorage.getItem("general_role"));
  const standardList = [];
  const sectionList = [];
  const subjectList = [];
  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
    subjects: null,
  });
  const [nameOfQB, setQBName] = useState("");
  const [specialChar, setSpecialChar] = useState(false);
  const [click, setClick] = useState(false);
  const { standards, sections, subjects } = dropdownLists;

  const [assessmentDetails, setAssessmentDetails] = useState({
    name: "",
    description: "",
    teacher_id: null,
    type_id: "",
    standard_id: {
      id: "",
      name: "",
    },
    section_id: {
      id: "",
      name: "",
    },
    subject_id: {
      id: "",
      name: "",
    },
    tags: [],
    status: null,
    total_duration: null,
    schedule_date: null,
    schedule_time: null,
    add_to_live_session: {
      lecture_id: null,
      date: null,
    },
    questions: [],
  });

  const initialAssessmentDetails = {
    name: "",
    description: "",
    teacher_id: null,
    type_id: "",
    standard_id: { id: "", name: "" },
    section_id: { id: "", name: "" },
    subject_id: { id: "", name: "" },
    tags: [],
    status: null,
    total_duration: null,
    schedule_date: null,
    schedule_time: null,
    add_to_live_session: { lecture_id: null, date: null },
    questions: [],
  };

  useEffect(() => {
    if (!assessmentDetails) return;

    const timer = setTimeout(() => {
      const prev = JSON.parse(
        localStorage.getItem("temp_Questions_QUESTION_BANK") || "null",
      );

      // 1. Agar localStorage empty h aur state initial hi h => skip
      if (
        !prev &&
        JSON.stringify(assessmentDetails) ===
          JSON.stringify(initialAssessmentDetails)
      ) {
        console.log("⚡ Initial empty state, skip saving");
        return;
      }

      // 2. Agar prev aur new same h => skip
      if (
        prev?.questionBankData &&
        JSON.stringify(prev?.questionBankData) ===
          JSON.stringify(assessmentDetails)
      ) {
        console.log("⚡ No changes in assessmentDetails, skip saving");
        return;
      }

      if (prev) {
        // 3. Save to localStorage
        localStorage.setItem(
          "temp_Questions_QUESTION_BANK",
          JSON.stringify({
            questionBankData: assessmentDetails,
            questions: prev?.questions,
          }),
        );
      }
      console.log("⬅️ Saved questionBank to tempQuestionBank");
    }, 3000);

    return () => clearTimeout(timer);
  }, [assessmentDetails]);

  useEffect(() => {
    const saved = JSON.parse(
      localStorage.getItem("temp_Questions_QUESTION_BANK"),
    );

    if (saved && saved?.questions?.length > 0) {
      setAssessmentDetails(saved.questionBankData);

      console.log("⬅️ Restored questionBank from tempQuestionBank");
    }
  }, []);

  useEffect(() => {
    if (CTRole_Information && CTRole_Information.length > 0) {
      CTRole_Information?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }
    if (CoRole_Information && CoRole_Information.length > 0) {
      CoRole_Information?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }
    if (general_role && general_role.length > 0) {
      general_role?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }
    standardList.length > 0 &&
      setDropdownLists((prev) => ({ ...prev, standards: standardList }));

    sectionList.length > 0 &&
      setDropdownLists((prev) => ({ ...prev, sections: sectionList }));
    // subjectList.length > 0 &&
    //     setDropdownLists((prev) => ({ ...prev, subjects: subjectList }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSubjects = async (standard_id, section_id) => {
    let arrSubject = [];
    try {
      let res = await axios.get(
        `/api/v1/school/standardId/${standard_id}/sectionId/${section_id}/getSubjects`,
      );

      const data = res?.data?.data;

      // Priority: subjectConfigurations > subjects
      const subjectSource =
        data?.subjectConfigurations?.length > 0
          ? data.subjectConfigurations.map((item) => item.subject)
          : data.subjects;

      subjectSource.forEach((obj) => {
        arrSubject.push(obj);
      });
    } catch (error) {
      console.log(error);
    }
    return arrSubject;
  };

  useEffect(() => {
    (async () => {
      let subjects = [];
      if (
        ((CTRole_Information && CTRole_Information.length > 0) ||
          (CoRole_Information && CoRole_Information.length > 0)) &&
        assessmentDetails.standard_id?.id !== "null" &&
        assessmentDetails.section_id?.id !== "null"
      ) {
        subjects = await getSubjects(
          assessmentDetails.standard_id?.id,
          assessmentDetails.section_id?.id,
        ); //obj.subjects_id;
      }
      if (CTRole_Information && CTRole_Information.length > 0) {
        CTRole_Information?.forEach(async (obj) => {
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (CoRole_Information && CoRole_Information.length > 0) {
        CoRole_Information?.forEach(async (obj) => {
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (general_role && general_role.length > 0) {
        general_role?.forEach((obj) => {
          let subjects = obj.subjects_id;
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            for (const subject of subjects) {
              if (!subjectList.some((i) => i.id === subject.id)) {
                subjectList.push({ id: subject.id, name: subject.name });
              }
            }
          }
        });
      }
      subjectList.length > 0 &&
        setDropdownLists((prev) => ({ ...prev, subjects: subjectList }));
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentDetails.standard_id, assessmentDetails.section_id]);

  const isDisabled =
    !assessmentDetails.name.trim() ||
    !assessmentDetails.standard_id?.id ||
    !assessmentDetails.section_id?.id ||
    !assessmentDetails.subject_id?.id ||
    assessmentDetails.subject_id?.id === "null" ||
    assessmentDetails.section_id?.id === null;
  return (
    <>
      {!click && (
        <div>
          <div className="d-flex gap-2 align-items-center">
            <IoIosArrowBack
              onClick={() => navigate("/questionLibrary")}
              style={{ cursor: "pointer" }}
            />

            <div
              className="d-flex flex-column gap-1"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/questionLibrary")}
            >
              <span className="head_manual">Question Bank</span>
              <span
                className="fw-small  text-muted"
                style={{ fontSize: "10px" }}
              >
                Dashboard / Question Bank / Create New
              </span>
            </div>
          </div>
          <div
            className="w-100 h-100 py-2  mt-4"
            style={{ backgroundColor: "#fff" }}
          >
            <div className="m-5">
              <div className="heading_QB_create">Enter Question Bank Name</div>
              <div className="inputsWidth">
                <div className="mt-4">
                  <input
                    className="form-control"
                    id={
                      assessmentDetails.name.trim().length > 0
                        ? "byeInput"
                        : "belloInput"
                    }
                    placeholder="Name"
                    // onChange={(e) => {
                    //   const value = e.target.value;
                    //   const regex = /^([^"/|\\;\-+(){}%!?*&=`']*?)?$/;
                    //   if (regex.test(value) || value === "") {
                    //     setQBName(value);
                    //     setAssessmentDetails({
                    //       ...assessmentDetails,
                    //       name: value,
                    //     });
                    //     setSpecialChar(false);

                    //   } else {

                    //     if (value !== "") {
                    //       setSpecialChar(true);
                    //     }
                    //   }
                    // }}
                    onChange={(e) => {
                      const value = e.target.value;

                      setQBName(value);
                      setAssessmentDetails({
                        ...assessmentDetails,
                        name: value,
                      });

                      // special char ka error bhi abhi off kar dena
                      setSpecialChar(false);
                    }}
                    value={assessmentDetails.name}
                    maxLength={50}
                  />
                </div>
                {specialChar && (
                  <p className="SpclStyle mt-2">
                    *Special Character Not Allowed.
                  </p>
                )}

                <div
                  className="mt-3 ipDropdowns gap-2"
                  style={{ display: "flex", gap: "1rem" }}
                >
                  {/* Class Select */}
                  <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
                    <InputLabel>Select Class</InputLabel>
                    <Select
                      label="Select Class"
                      value={assessmentDetails.standard_id.id || ""}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selected = standards.find(
                          (s) => s.id === selectedId,
                        );
                        setAssessmentDetails({
                          ...assessmentDetails,
                          standard_id: {
                            id: selectedId,
                            name: selected?.name || "null",
                          },
                          subject_id: { id: "null", name: "null" },
                          section_id: { id: "null", name: "null" },
                        });
                      }}
                    >
                      <MenuItem value="">Select Class</MenuItem>
                      {standards?.length > 0 &&
                        [...standards]
                          .sort((a, b) => {
                            const aNum = Number(a.name);
                            const bNum = Number(b.name);

                            const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                            if (bothNumeric) {
                              return aNum - bNum; // numeric sort
                            }

                            return a.name.localeCompare(b.name); // alphabetical sort
                          })
                          .map((standard, index) => (
                            <MenuItem
                              key={index}
                              value={standard?.id}
                              name={standard?.name}
                            >
                              {standard?.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>

                  {/* Section Select */}
                  <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
                    <InputLabel>Select Section</InputLabel>
                    <Select
                      label="Select Section"
                      value={assessmentDetails.section_id.id || ""}
                      disabled={
                        assessmentDetails.standard_id.id === "null" ||
                        !assessmentDetails.standard_id.id
                      }
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selected = sections.find(
                          (s) => s.id === selectedId,
                        );
                        setAssessmentDetails({
                          ...assessmentDetails,
                          section_id: {
                            id: selectedId,
                            name: selected?.name || "null",
                          },
                          subject_id: { id: "null", name: "null" },
                        });
                      }}
                    >
                      <MenuItem value="">Select Section</MenuItem>
                      {assessmentDetails.standard_id.id !== "null" &&
                        sections
                          ?.slice()
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((section, index) => (
                            <MenuItem key={index} value={section.id}>
                              {section.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>

                  {/* Subject Select */}
                  <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
                    <InputLabel>Select Subject</InputLabel>
                    <Select
                      label="Select Subject"
                      value={assessmentDetails.subject_id.id || ""}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selected = subjects.find(
                          (s) => s.id === selectedId,
                        );
                        setAssessmentDetails({
                          ...assessmentDetails,
                          subject_id: {
                            id: selectedId,
                            name: selected?.name || "null",
                          },
                        });
                      }}
                      disabled={
                        assessmentDetails.standard_id.id === "null" ||
                        assessmentDetails.section_id.id === "null" ||
                        !assessmentDetails.standard_id.id ||
                        !assessmentDetails.section_id.id
                      }
                    >
                      <MenuItem value="">Select Subject</MenuItem>
                      {assessmentDetails.standard_id.id !== "null" &&
                        assessmentDetails.section_id.id !== "null" &&
                        subjects?.map((subject, index) => (
                          <MenuItem key={index} value={subject.id}>
                            {subject.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
            {console.log(assessmentDetails, "assessmentDetails")}
            <div className="d-flex justify-content-end">
              <button
                className={isDisabled ? "Next_buttonDisable" : "button_css"}
                style={{ marginRight: "17rem" }}
                disabled={isDisabled}
                onClick={() => setClick(true)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
      {click && (
        <CreateQuestion
          componentType={ComponentType.QUESTION_BANK}
          setClickFromCreate={setClick}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
        />
      )}
    </>
  );
}
